import React, { useState, useEffect, Suspense } from "react";
import { Link } from "react-router-dom";
import { Badge, CardFooter, Progress, Container, Row, Col } from "reactstrap";
import moment from "moment";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import dateFormat from "dateformat";
import {
  Paper,
  TableContainer,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import CancelIcon from "@mui/icons-material/Cancel";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import HeaderStats1 from "components/Headers/HeaderStats1.js";

const duration = 1;
const InprogressState = (props) => {
  const { executionStatus, auditDate } = props;

  const datecheck = new Date(auditDate);
  const day = datecheck.getDate();
  const month = datecheck.getMonth() + 1;
  const year = datecheck.getFullYear();
  const hours = datecheck.getHours();
  const minutes = datecheck.getMinutes();

  const finalDate = `${year}-${month}-${day}`;

  const cnow = new Date();
  const currentday = cnow.getDate();
  const currnetmonth = cnow.getMonth() + 1;
  const currentyear = cnow.getFullYear();
  const currnethours = cnow.getHours();
  const currentminutes = cnow.getMinutes();

  const currentDate = `${currentyear}-${currnetmonth}-${currentday}`;

  var dt = moment(datecheck, ["h:mm A"]).format("HH:mm A");
  const [hours1, minutes1] = dt.split(":");
  const extraTime = parseInt(duration) + parseInt(hours1);

  var show;
  if (currentDate === finalDate) {
    if (extraTime <= 24) {
      if (currnethours <= extraTime) {
        show = true;
      } else {
        show = false;
      }
    } else {
      const newvalue = extraTime - 24;
      if (currnethours === newvalue) {
        show = true;
      } else {
        show = false;
      }
    }
  } else {
    show = false;
  }
  return show ? (
    <React.Fragment>
      <Brightness1Icon style={{ fontSize: "8px", color: "lightgray" }} />
      <span> {executionStatus}</span>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Brightness1Icon style={{ fontSize: "8px", color: "gold" }} />
      <span> Time-out</span>
    </React.Fragment>
  );
};

const Header = () => {
  const [countlist, setlists] = useState([]);
  const [auditactivity, setaudit] = useState([]);
  const [remedyactivity, setremedy] = useState([]);
  const [rollbackactivity, setrollback] = useState([]);
  const [hostlist, setlist] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/count`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setlists(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/audit_activity`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setaudit(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/remedy_activity`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setremedy(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/rollback_activity`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setrollback(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/hosts/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [healthy, sethealthy] = useState([]);
  const [warning, setwarning] = useState([]);
  const [critical, setcritical] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/host_healthy_status`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => sethealthy(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/host_warning_status`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setwarning(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/host_critical_status`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setcritical(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  return (
    <>
      <HeaderStats1 />
      <Container fluid>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card body outline>
              <CardHeader
                titleTypographyProps={{ variant: "subtitle1" }}
                title="Healthy"
                avatar={<CheckCircleIcon style={{ color: "green" }} />}
              />
              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 1050 }}>
                  <CardContent>
                    {healthy.length > 0 ? (
                      <Table>
                        <TableHead className="bg-lightBlue-200">
                          <TableRow>
                            <TableCell align="center">Host Name</TableCell>
                            <TableCell align="center">Platform</TableCell>
                            <TableCell align="center">Executed on</TableCell>
                            <TableCell align="center">Status</TableCell>
                            <TableCell align="center">Details</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {healthy.map((audit, Index) => {
                            if (Index <= 3) {
                              return (
                                <TableRow>
                                  <TableCell align="center">
                                    <span className="mb-0 text-sm">
                                      {audit.Hostname}
                                    </span>
                                  </TableCell>
                                  <TableCell align="center">
                                    {audit.Platform}
                                  </TableCell>
                                  <TableCell align="center">
                                    {dateFormat(
                                      audit.Executed_at,
                                      "mmmm dS, yyyy h:MM TT "
                                    )}
                                    (IST)
                                  </TableCell>
                                  <TableCell align="center">
                                    {" "}
                                    <Progress
                                      color="success"
                                      value={audit.passedAverage}
                                      style={{ height: "19px" }}
                                    >
                                      {audit.passedAverage}%
                                    </Progress>
                                  </TableCell>
                                  <TableCell align="center">
                                    <div
                                      className="col text-right"
                                      style={{ textAlignLast: "center" }}
                                    >
                                      <button
                                        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                        size="sm"
                                      >
                                        <Link
                                          to={{
                                            pathname:
                                              "/admin/auditdetailedview",
                                          }}
                                          onClick={() => {
                                            sessionStorage.setItem(
                                              "hostID",
                                              audit.host
                                            );
                                            sessionStorage.setItem(
                                              "auditID",
                                              audit.id
                                            );
                                            sessionStorage.setItem(
                                              "OS",
                                              audit.platform
                                            );
                                          }}
                                          style={{ color: "#FFF" }}
                                        >
                                          Details
                                        </Link>
                                      </button>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          })}
                        </TableBody>
                      </Table>
                    ) : (
                      <CardContent> No Host Available ...</CardContent>
                    )}
                  </CardContent>
                </TableContainer>
              </Paper>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card body outline color="info">
              <CardHeader
                titleTypographyProps={{ variant: "subtitle1" }}
                title="Warning"
                avatar={<WarningIcon style={{ color: "blue" }} />}
              ></CardHeader>
              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 1050 }}>
                  <CardContent>
                    {warning.length > 0 ? (
                      <Table>
                        <TableHead className="bg-lightBlue-200">
                          <TableRow>
                            <TableCell align="center">Host Name</TableCell>
                            <TableCell align="center">Platform</TableCell>
                            <TableCell align="center">Executed on</TableCell>
                            <TableCell align="center">Status</TableCell>
                            <TableCell align="center">Details</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {warning.map((audit, Index) => {
                            if (Index <= 3) {
                              return (
                                <TableRow>
                                  <TableCell align="center">
                                    <span className="mb-0 text-sm">
                                      {audit.Hostname}
                                    </span>
                                  </TableCell>
                                  <TableCell align="center">
                                    {audit.Platform}
                                  </TableCell>
                                  <TableCell align="center">
                                    {dateFormat(
                                      audit.Executed_at,
                                      "mmmm dS, yyyy h:MM TT "
                                    )}
                                    (IST)
                                  </TableCell>
                                  <TableCell align="center">
                                    {" "}
                                    <Progress
                                      value={audit.passedAverage}
                                      style={{ height: "19px" }}
                                    >
                                      {audit.passedAverage}%
                                    </Progress>
                                  </TableCell>
                                  <TableCell align="center">
                                    <div
                                      className="col text-right"
                                      style={{ textAlignLast: "center" }}
                                    >
                                      <button
                                        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                        size="sm"
                                      >
                                        <Link
                                          to={{
                                            pathname:
                                              "/admin/auditdetailedview",
                                          }}
                                          onClick={() => {
                                            sessionStorage.setItem(
                                              "hostID",
                                              audit.host
                                            );
                                            sessionStorage.setItem(
                                              "auditID",
                                              audit.id
                                            );
                                            sessionStorage.setItem(
                                              "OS",
                                              audit.platform
                                            );
                                          }}
                                          style={{ color: "#FFF" }}
                                        >
                                          Details
                                        </Link>
                                      </button>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          })}
                        </TableBody>
                      </Table>
                    ) : (
                      <CardContent> No Host Available ...</CardContent>
                    )}
                  </CardContent>
                </TableContainer>
              </Paper>
              <CardActions></CardActions>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card body outline>
              <CardHeader
                titleTypographyProps={{ variant: "subtitle1" }}
                title="Critical"
                avatar={<CancelIcon style={{ color: "red" }} />}
              ></CardHeader>
              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 1050 }}>
                  <CardContent>
                    {critical.length > 0 ? (
                      <Table>
                        <TableHead className="bg-lightBlue-200">
                          <TableRow>
                            <TableCell align="center">Host Name</TableCell>
                            <TableCell align="center">Platform</TableCell>
                            <TableCell align="center">Executed on</TableCell>
                            <TableCell align="center">Status</TableCell>
                            <TableCell align="center">Details</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {critical.map((audit, Index) => {
                            if (Index <= 3) {
                              return (
                                <TableRow>
                                  <TableCell align="center">
                                    <span className="mb-0 text-sm">
                                      {audit.Hostname}
                                    </span>
                                  </TableCell>
                                  <TableCell align="center">
                                    {audit.Platform}
                                  </TableCell>
                                  <TableCell align="center">
                                    {dateFormat(
                                      audit.Executed_at,
                                      "mmmm dS, yyyy h:MM TT "
                                    )}
                                    (IST)
                                  </TableCell>
                                  <TableCell align="center">
                                    {" "}
                                    <Progress
                                      color="danger"
                                      value={audit.passedAverage}
                                      style={{ height: "19px" }}
                                    >
                                      {audit.passedAverage}%
                                    </Progress>
                                  </TableCell>
                                  <TableCell align="center">
                                    <div
                                      className="col text-right"
                                      style={{ textAlignLast: "center" }}
                                    >
                                      <button
                                        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                        size="sm"
                                      >
                                        <Link
                                          to={{
                                            pathname:
                                              "/admin/auditdetailedview",
                                          }}
                                          onClick={() => {
                                            sessionStorage.setItem(
                                              "hostID",
                                              audit.host
                                            );
                                            sessionStorage.setItem(
                                              "auditID",
                                              audit.id
                                            );
                                            sessionStorage.setItem(
                                              "OS",
                                              audit.platform
                                            );
                                          }}
                                          style={{ color: "#FFF" }}
                                        >
                                          Details
                                        </Link>
                                      </button>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          })}
                        </TableBody>
                      </Table>
                    ) : (
                      <CardContent> No Host Available ...</CardContent>
                    )}
                  </CardContent>
                </TableContainer>
              </Paper>
              <CardActions></CardActions>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="shadow">
              <CardHeader
                action={
                  <React.Fragment>
                    <button
                      className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                      style={{ float: "right" }}
                    >
                      <Link
                        to={{ pathname: "/admin/audit" }}
                        style={{ color: "#FFF" }}
                      >
                        See all
                      </Link>
                    </button>
                  </React.Fragment>
                }
                titleTypographyProps={{ variant: "subtitle1" }}
                title="Audit Activity"
              />
              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 1050 }}>
                  <Table>
                    <TableHead className="bg-lightBlue-200">
                      <TableRow>
                        <TableCell align="center">Host Name</TableCell>
                        <TableCell align="center">Platform</TableCell>
                        <TableCell align="center">Executed on</TableCell>
                        <TableCell align="center">Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {auditactivity.map((audit) => {
                        return (
                          <TableRow>
                            {hostlist.map((hostlist) => {
                              return (
                                <Suspense fallback={<p>loading...</p>}>
                                  <React.Fragment>
                                    {audit.host === hostlist.id ? (
                                      <TableCell align="center">
                                        <span className="mb-0 text-sm">
                                          {hostlist.hostname}
                                        </span>
                                      </TableCell>
                                    ) : (
                                      ""
                                    )}
                                  </React.Fragment>
                                </Suspense>
                              );
                            })}
                            <TableCell align="center">
                              {audit.platform}
                            </TableCell>
                            <TableCell align="center">
                              {dateFormat(
                                audit.audit_date,
                                "mmmm dS, yyyy h:MM TT "
                              )}
                              (IST)
                            </TableCell>
                            <TableCell align="center">
                              {audit.execution_status === "Succeeded" ? (
                                <React.Fragment>
                                  <Brightness1Icon
                                    style={{
                                      fontSize: "8px",
                                      color: "greenyellow",
                                    }}
                                  />
                                  <span> Succeeded</span>
                                </React.Fragment>
                              ) : audit.execution_status === "Failed" ? (
                                <React.Fragment>
                                  <Brightness1Icon
                                    style={{
                                      fontSize: "8px",
                                      color: "palevioletred",
                                    }}
                                  />
                                  <span> {audit.execution_status}</span>
                                </React.Fragment>
                              ) : audit.execution_status === "In Progress" ? (
                                <InprogressState
                                  executionStatus={audit.execution_status}
                                  auditDate={audit.audit_date}
                                />
                              ) : (
                                ""
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              <CardActions style={{ float: "center", alignSelf: "center" }}>
                {auditactivity.length > 0 ? (
                  ""
                ) : (
                  <span>No Audit Available ...</span>
                )}
              </CardActions>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="shadow">
              <CardHeader
                action={
                  <React.Fragment>
                    <button
                      className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                      style={{ float: "right" }}
                    >
                      <Link
                        to={{ pathname: "/admin/remedy" }}
                        style={{ color: "#FFF" }}
                      >
                        See all
                      </Link>
                    </button>
                  </React.Fragment>
                }
                titleTypographyProps={{ variant: "subtitle1" }}
                title="Remedy Activity"
              />

              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 1050 }}>
                  <Table>
                    <TableHead className="bg-lightBlue-200">
                      <TableRow>
                        <TableCell align="center">Host Name</TableCell>
                        <TableCell align="center">Platform</TableCell>
                        <TableCell align="center">Executed on</TableCell>
                        <TableCell align="center">Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {remedyactivity.map((remedy) => {
                        return (
                          <TableRow>
                            {hostlist.map((hostlist) => {
                              return (
                                <Suspense fallback={<p>loading...</p>}>
                                  <React.Fragment>
                                    {remedy.host === hostlist.id ? (
                                      <TableCell align="center">
                                        <span className="mb-0 text-sm">
                                          {hostlist.hostname}
                                        </span>
                                      </TableCell>
                                    ) : (
                                      ""
                                    )}
                                  </React.Fragment>
                                </Suspense>
                              );
                            })}
                            <TableCell align="center">
                              {remedy.platform}
                            </TableCell>
                            <TableCell align="center">
                              {dateFormat(
                                remedy.remedy_date,
                                "mmmm dS, yyyy h:MM TT "
                              )}
                              (IST)
                            </TableCell>
                            <TableCell align="center">
                              {remedy.execution_status === "Succeeded" ? (
                                <React.Fragment>
                                  <Brightness1Icon
                                    style={{
                                      fontSize: "8px",
                                      color: "greenyellow",
                                    }}
                                  />
                                  <span> Succeeded</span>
                                </React.Fragment>
                              ) : remedy.execution_status === "Failed" ? (
                                <React.Fragment>
                                  <Brightness1Icon
                                    style={{
                                      fontSize: "8px",
                                      color: "palevioletred",
                                    }}
                                  />
                                  <span> {remedy.execution_status}</span>
                                </React.Fragment>
                              ) : (
                                ""
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              <CardActions style={{ float: "center", alignSelf: "center" }}>
                {remedyactivity.length > 0 ? (
                  ""
                ) : (
                  <span>No Remedy Available ...</span>
                )}
              </CardActions>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="shadow">
              <CardHeader
                action={
                  <React.Fragment>
                    <button
                      className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                      style={{ float: "right" }}
                    >
                      <Link
                        to={{ pathname: "/admin/rollback" }}
                        style={{ color: "#FFF" }}
                      >
                        See all
                      </Link>
                    </button>
                  </React.Fragment>
                }
                titleTypographyProps={{ variant: "subtitle1" }}
                title="Rollback Activity"
              />
              <Paper sx={{ width: "100%" }}>
                <TableContainer sx={{ maxHeight: 1050 }}>
                  <Table>
                    <TableHead className="bg-lightBlue-200">
                      <TableRow>
                        <TableCell align="center">Host Name</TableCell>
                        <TableCell align="center">Platform</TableCell>
                        <TableCell align="center">Executed on</TableCell>
                        <TableCell align="center">Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rollbackactivity.map((rollback) => {
                        return (
                          <TableRow>
                            {hostlist.map((hostlist) => {
                              return (
                                <Suspense fallback={<p>loading...</p>}>
                                  <React.Fragment>
                                    {rollback.host === hostlist.id ? (
                                      <TableCell align="center">
                                        <span className="mb-0 text-sm">
                                          {hostlist.hostname}
                                        </span>
                                      </TableCell>
                                    ) : (
                                      ""
                                    )}
                                  </React.Fragment>
                                </Suspense>
                              );
                            })}
                            <TableCell align="center">
                              {rollback.platform}
                            </TableCell>
                            <TableCell align="center">
                              {dateFormat(
                                rollback.rollback_date,
                                "mmmm dS, yyyy h:MM TT "
                              )}
                              (IST)
                            </TableCell>
                            <TableCell align="center">
                              {rollback.execution_status === "Succeeded" ? (
                                <React.Fragment>
                                  <Brightness1Icon
                                    style={{
                                      fontSize: "8px",
                                      color: "greenyellow",
                                    }}
                                  />
                                  <span> Succeeded</span>
                                </React.Fragment>
                              ) : rollback.execution_status === "Failed" ? (
                                <React.Fragment>
                                  <Brightness1Icon
                                    style={{
                                      fontSize: "8px",
                                      color: "palevioletred",
                                    }}
                                  />
                                  <span> {rollback.execution_status}</span>
                                </React.Fragment>
                              ) : rollback.execution_status ===
                                "In Progress" ? (
                                <InprogressState
                                  executionStatus={rollback.execution_status}
                                  auditDate={rollback.audit_date}
                                />
                              ) : (
                                ""
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              <CardActions style={{ float: "center", alignSelf: "center" }}>
                {rollbackactivity.length > 0 ? (
                  ""
                ) : (
                  <span>No Rollback Available ...</span>
                )}
              </CardActions>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Header;